import TransparentPageLayout from "../../../layout/page-layout/TransparentPageLayout";
import FlexBox from "../../../components/utilities/FlexBox";
import {useEffect, useState, useContext} from "react";
import {Button} from "react-bootstrap";
import checkEmail from "../../user/login-register/Utilities";
import axios from "axios";
import {checkMobile} from "../../../utilities/Utilities";
import {API_URL_PREFIX, APP_URL_PREFIX} from "../../../utilities/Constants";
import {useNavigate, useParams} from "react-router-dom";
import {CustomErrorToast, CustomToastContainer} from "../../../components/utilities/CustomToast";
import CompanyTeamContext from "../../../CompanyTeamContext";
import nameIcon from "../../../assets/candidate-new/nameIcon.svg";
import phoneIcon from "../../../assets/candidate-new/phoneIcon.svg";
import emailIcon from "../../../assets/candidate-new/emailIcon.svg";
import notesIcon from "../../../assets/candidate-new/notesIcon.svg";
import NotesInput from "../input-candidate-info/NotesInput";
import InputCandidateInfo from "../input-candidate-info/InputCandidateInfo";
import UpdateAndAddButton from "../bottom_buttons/UpdateAndAddButton";
import CancelButton from "../bottom_buttons/CancelButton";
import mainImage from "../../../assets/candidate-new/mainImage.svg";
import "./NewCandidate.css";



const NewCandidate = () => {
    const [name, setName] = useState({firstName: "", middleName: "", lastName: ""})
    const [email, setEmail] = useState("")
    const [mobile, setMobile] = useState("")
    const [notes, setNotes] = useState("")
    const [submit, setSubmit] = useState(false)
    const {id} = useParams();
    const navigate = useNavigate()
    const company = useContext(CompanyTeamContext)
    
    useEffect(() => {
        if (id) {
            axios.get(API_URL_PREFIX+"/GetCandidate.html?id=" + id)
                .then(res => res.data)
                .then(data => {
                    if (data) {
                        const {firstName, middleName, lastName, email, mobile, notes} = data
                        setName({firstName, middleName, lastName});
                        setEmail(email)
                        setMobile(mobile)
                        setNotes(notes)
                        if(company){
                            document.title  = firstName+" - " + company.basicTitle
                        }

                    }
                })
                .catch()
        }
        else{
            if(company){
                document.title  = "New Candidate - " + company.basicTitle
            }
        }
        return () => {
            if(company){
                document.title = company.basicTitle
            }
        }

    }, [id, company])

    const saveCandidate = () => {
        if (!name.firstName || !name.lastName) {
            CustomErrorToast("Fill the candidate name.")
            return;
        }
        if(mobile && !checkMobile(mobile)){
            CustomErrorToast("Invalid mobile number.")
            return;
        }
        if (!email) {
            CustomErrorToast("Fill the candidate email.")
            return;
        } else {
            if (!checkEmail(email)) {
                CustomErrorToast("Invalid candidate email.")
                return;
            }
        }
        setSubmit(true)
        const successHandler = (res) => {
            setSubmit(false)
            if (res.data.result) {
                // refresh the candidates
                navigate( APP_URL_PREFIX+"/candidate/" + res.data.info);
            } else {
                CustomErrorToast(res.data.info || "Error saving candidate, Please try again.")
            }
        }
        const errorHandler = (error) => {
            setSubmit(false)
            CustomErrorToast(error)
        }


        if (!id) {
            axios.post(API_URL_PREFIX+"/AddCandidate.html", {...name, email, mobile, notes})
                .then(successHandler)
                .catch(errorHandler)
        } else {
            axios.post(API_URL_PREFIX+"/AddCandidate.html", {key:id,...name, email, mobile, notes})
                .then(successHandler)
                .catch(errorHandler)
        }

    }

    return (
        <TransparentPageLayout>
            <CustomToastContainer/>

            {/* Mobile Title - hidden on desktop */}
            <div className="mobile-candidate-title">
                {id ? "Update" : "Add New"} Candidate
            </div>

            <div
                className="new-candidate-container"
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "993px",
                    height: "608px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                }}
            >

                <FlexBox direction={"column"} justify={"space-between"} align={"start"}
                        className={"hard-shadow new-candidate-card"}
                        style={{background: "#fff", height: "100%", width: "100%", borderRadius: "14px", display: "flex", flexDirection: "column"}}>
                    <div className="new-candidate-header" style={{
                        background: "#5c54ee",
                        borderRadius: "14px 14px 0 0",
                        color: "#fff",
                        fontSize: "20px",
                        width: "100%",
                        padding: "15px 30px", marginBottom: "-20px",
                    }}>{id ? "Update" : "Add New"} Candidate
                    </div>


                    <div className="new-candidate-form" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

                        <FlexBox className="new-candidate-name-row" justify={"start"} align={"end"} style={{width: "100%", padding: "0px 30px"}}>
                            <div className="name-input-wrapper name-first">
                                <InputCandidateInfo idName={"firstName"} required={true} placeHolder={"First Name"} field={name.firstName}
                                        setField={e => setName({...name, firstName: e.target.value})} icon={nameIcon}/>
                            </div>
                            <div className="name-input-wrapper name-middle">
                                <InputCandidateInfo placeHolder={"Middle Name"} field={name.middleName}
                                        setField={e => setName({...name, middleName: e.target.value})} icon={nameIcon}/>
                            </div>
                            <div className="name-input-wrapper name-last">
                                <InputCandidateInfo idName={"lastName"} required={true} placeHolder={"Last Name"} field={name.lastName}
                                        setField={e => setName({...name, lastName: e.target.value})} icon={nameIcon}/>
                            </div>
                        </FlexBox>

                        <FlexBox className="new-candidate-contact-row" justify={"start"} align={"end"}
                                style={{width: "100%", padding: "10px 30px"}}>
                            <div className="contact-input-wrapper contact-email">
                                <InputCandidateInfo idName={"email"} required={true} placeHolder={"Email"} field={email} setField={e => setEmail(e.target.value)} icon={emailIcon}/>
                            </div>
                            <div className="contact-input-wrapper contact-mobile">
                                <InputCandidateInfo type={"tel"} placeHolder={"Mobile Phone"} field={mobile} setField={e => setMobile(e.target.value)} icon={phoneIcon}/>
                            </div>
                            <br className="contact-br"/>
                            <br className="contact-br"/>
                        </FlexBox>
                        <FlexBox
                            className="new-candidate-notes-row"
                            justify={"start"}
                            align={"end"}
                            style={{ width: "100%", padding: "10px 30px"}}
                            >
                            <div className="notes-input-wrapper">
                                <NotesInput
                                    placeHolder="Notes"
                                    field={notes}
                                    setField={(e) => setNotes(e.target.value)}
                                    icon={notesIcon}
                                    height="178px"
                                    width="432px"
                                />
                            </div>
                        </FlexBox>
                    </div>

                    <img className="new-candidate-illustration" src={mainImage} alt="Main" style={{
                            position: "absolute",
                            top: "230px",
                            left: "550px",
                            width: "298px",
                            height: "298px"
                        }}
                        />

                    <FlexBox className="new-candidate-buttons-row" justify={"space-between"} align={"end"}
                            style={{width: "100%", padding: "10px 30px", }}>


                        <CancelButton onClick={() => navigate(-1)}>
                            Cancel
                        </CancelButton>


                        <UpdateAndAddButton id={"saveCandidate"} disabled={submit} onClick={saveCandidate}>
                            {id ? "Update" : "Save"}
                        </UpdateAndAddButton>



                    </FlexBox>
                </FlexBox>
            </div>
        </TransparentPageLayout>
    )

}
export default NewCandidate